import { Container, Row, Col } from "reactstrap";
import styles from "./styles.module.scss";

export const ContentBanner = ({
  className,
  title,
  heading,
  titleColour,
  content,
  image,
  reversed,
}) => {

  return (
    <section className={`${styles.root} ${className} ${reversed ? "reversed" : ""}`}>
      <Container>
        <Row className={`m-0 ${reversed ? "flex-row-reverse" : ""}`}>
          <Col lg={6} className="contentWrapper d-flex flex-wrap align-items-center position-relative">
            <div>
              <h2
                className={`text-${titleColour?.variant} ${heading}`}
                style={titleColour?.custom ? { color: titleColour?.custom } : null}
              >
                {title}
              </h2>
              {content &&
                <div className="mt-4" dangerouslySetInnerHTML={{ __html: content }} />
              }
            </div>
          </Col>
          <figure className="imageWrapper position-absolute p-0 m-0">
            <img src={image?.url ? image?.url : "/site-assets/images/sub-banner-about-us.png"} alt={image?.alt} loading="eager" className="card-img rounded-0" />
          </figure>
        </Row>
      </Container>
    </section>
  );

}

export default ContentBanner;
